import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const Exceptions = {
  Content: lazy(
    () =>
      import('components/direct-sales/exceptions/components/ExceptionsContent')
  ),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default Exceptions;
